export default "__VITE_ASSET__a8e23ee8__"